var map = {
	"./1x1.png": 9882,
	"./Banner_Topspiel_300x250.png": 9362,
	"./HBF-Banner-neue_Homepage_300x250_v1.png": 8007,
	"./flags/flag_at.svg": 2424,
	"./flags/flag_az.svg": 2622,
	"./flags/flag_be.svg": 3808,
	"./flags/flag_br.svg": 1727,
	"./flags/flag_by.svg": 6100,
	"./flags/flag_ca.svg": 4499,
	"./flags/flag_ch.svg": 9994,
	"./flags/flag_cn.svg": 7460,
	"./flags/flag_cs.svg": 5729,
	"./flags/flag_cz.svg": 8600,
	"./flags/flag_de.svg": 5246,
	"./flags/flag_dk.svg": 2376,
	"./flags/flag_ee.svg": 2925,
	"./flags/flag_es.svg": 2547,
	"./flags/flag_fi.svg": 8576,
	"./flags/flag_fr.svg": 4587,
	"./flags/flag_gr.svg": 9436,
	"./flags/flag_hr.svg": 2247,
	"./flags/flag_hu.svg": 8962,
	"./flags/flag_ie.svg": 8481,
	"./flags/flag_is.svg": 1647,
	"./flags/flag_it.svg": 7856,
	"./flags/flag_jp.svg": 1957,
	"./flags/flag_lt.svg": 1895,
	"./flags/flag_lu.svg": 2358,
	"./flags/flag_me.svg": 9941,
	"./flags/flag_mk.svg": 467,
	"./flags/flag_nl.svg": 6693,
	"./flags/flag_no.svg": 5446,
	"./flags/flag_pl.svg": 8883,
	"./flags/flag_pt.svg": 8920,
	"./flags/flag_ro.svg": 714,
	"./flags/flag_rs.svg": 7774,
	"./flags/flag_ru.svg": 2688,
	"./flags/flag_se.svg": 8127,
	"./flags/flag_si.svg": 427,
	"./flags/flag_sk.svg": 745,
	"./flags/flag_sr.svg": 4416,
	"./flags/flag_tr.svg": 993,
	"./flags/flag_ua.svg": 113,
	"./fonts/overpass-bold.eot": 2259,
	"./fonts/overpass-bold.ttf": 5653,
	"./fonts/overpass-bold.woff": 8619,
	"./fonts/overpass-bold.woff2": 7683,
	"./fonts/overpass-extrabold.eot": 7773,
	"./fonts/overpass-extrabold.ttf": 8519,
	"./fonts/overpass-extrabold.woff": 5045,
	"./fonts/overpass-extrabold.woff2": 3597,
	"./fonts/overpass-regular.eot": 6610,
	"./fonts/overpass-regular.ttf": 604,
	"./fonts/overpass-regular.woff": 2700,
	"./fonts/overpass-regular.woff2": 4838,
	"./fonts/overpass-semibold.eot": 5269,
	"./fonts/overpass-semibold.ttf": 9823,
	"./fonts/overpass-semibold.woff": 9725,
	"./fonts/overpass-semibold.woff2": 5874,
	"./form-arrow.svg": 2336,
	"./ic_10_route.svg": 4660,
	"./ic_12_arrow-white.svg": 5010,
	"./ic_12_arrow.svg": 5814,
	"./ic_12_arrow_brand.svg": 280,
	"./ic_12_average.svg": 1516,
	"./ic_12_dropdown.svg": 4564,
	"./ic_12_siebenmeter.svg": 3846,
	"./ic_16_arrow.svg": 9874,
	"./ic_16_listswitch_card.svg": 964,
	"./ic_16_listswitch_list.svg": 5838,
	"./ic_16_livestream.svg": 2317,
	"./ic_16_liveticker.svg": 3123,
	"./ic_16_magnifier.svg": 3861,
	"./ic_16_share.svg": 4952,
	"./ic_16_sort_down.svg": 4542,
	"./ic_16_sort_up.svg": 8629,
	"./ic_20_info.svg": 6238,
	"./ic_20_play_liveticker.svg": 455,
	"./ic_20_transfer_in.svg": 7775,
	"./ic_20_transfer_out.svg": 970,
	"./ic_24_car.svg": 2024,
	"./ic_24_email.svg": 8270,
	"./ic_24_facebook.svg": 1398,
	"./ic_24_handy.svg": 6114,
	"./ic_24_instagram.svg": 1250,
	"./ic_24_ticket.svg": 3806,
	"./ic_24_twitter.svg": 6355,
	"./ic_24_website.svg": 2409,
	"./ic_24_youtube.svg": 1049,
	"./ic_32_social_facebook.svg": 1407,
	"./ic_32_social_instagram.svg": 3813,
	"./ic_32_social_linkedin.svg": 4969,
	"./ic_32_social_newsletter.svg": 5274,
	"./ic_32_social_podcast.svg": 2133,
	"./ic_32_social_shop.svg": 6943,
	"./ic_48_erfolg_aufstieg.svg": 5404,
	"./ic_48_erfolg_meister.svg": 117,
	"./ic_48_erfolg_pokal_international.svg": 3754,
	"./ic_48_erfolg_pokal_national.svg": 5764,
	"./ic_56_avatar.svg": 8224,
	"./ic_dropdown.svg": 5062,
	"./ic_nav_search.svg": 1175,
	"./ic_ranking_expand.svg": 4216,
	"./list-arrow-teams.svg": 5055,
	"./logo-alsco.png": 8822,
	"./logo-select.svg": 1936,
	"./logo-sportplatzmedia.svg": 671,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./player/player-portrait-empty-l.svg": 950,
	"./player/player-portrait-empty-m.svg": 3751,
	"./player/player-portrait-empty-s.svg": 6305,
	"./player/player-portrait-large.jpg": 4425,
	"./player/player-portrait-large@2x.jpg": 3163,
	"./player/player-portrait-more.svg": 5845,
	"./player/player-portrait-small.png": 2005,
	"./player/player-portrait-small@2x.png": 1855,
	"./slider-arrow.svg": 201,
	"./statistic-background.png": 9203,
	"./statistics-empty-graphic-desktop.png": 5013,
	"./statistics-empty-graphic-desktop@2x.png": 8559,
	"./statistics-empty-graphic-mobile.png": 8535,
	"./statistics-empty-graphic-mobile@2x.png": 3417,
	"./statistics-empty-icon.svg": 4487,
	"./teams/logo-leverkusen-20.png": 8322,
	"./teams/logo-leverkusen-200.png": 856,
	"./teams/logo-leverkusen-200@2x.png": 4160,
	"./teams/logo-leverkusen-20@2x.png": 9170,
	"./teams/logo-neckarsulm-20.png": 9339,
	"./teams/logo-neckarsulm-200.png": 8611,
	"./teams/logo-neckarsulm-200@2x.png": 9245,
	"./teams/logo-neckarsulm-20@2x.png": 5301,
	"./teams/mannschaft-leverkusen.jpg": 3847,
	"./teams/mannschaft-leverkusen@2x.jpg": 8958,
	"./testnews.jpg": 989,
	"./testslider.jpg": 3507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;